import React from 'react';

/** Базовый скелетон-блок */
const Skeleton = ({ className = '', style }) => (
  <div className={`bm-skeleton ${className}`} style={style} />
);

/** Скелетон карточки */
export const SkeletonCard = () => (
  <div className="bm-card" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Skeleton className="bm-skeleton--avatar" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Skeleton className="bm-skeleton--text" style={{ width: '60%' }} />
        <Skeleton className="bm-skeleton--text" style={{ width: '40%' }} />
      </div>
    </div>
    <Skeleton className="bm-skeleton--text" style={{ width: '100%' }} />
    <Skeleton className="bm-skeleton--text" style={{ width: '80%' }} />
  </div>
);

/** Скелетон списка */
export const SkeletonList = ({ count = 3 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

/** Скелетон текстового блока */
export const SkeletonText = ({ lines = 3 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className="bm-skeleton--text"
        style={{ width: i === lines - 1 ? '60%' : '100%' }}
      />
    ))}
  </div>
);

/** Скелетон сетки карточек */
export const SkeletonGrid = ({ count = 6 }) => (
  <div className="bm-grid">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export default Skeleton;
